// extracted by mini-css-extract-plugin
module.exports = {"projectsContainer":"CorporateContentModules_projectsContainer__BPWaH","firstItemContainer":"CorporateContentModules_firstItemContainer__O3tJN"};